import { useCallback, useRef } from 'react'

export
function useHookWithRefCallback(callback) {
  const ref = useRef(null)
  const setRef = useCallback(node => {
    if(node) {
      if(typeof callback === 'function') {
        callback()
      }
    }
    ref.current = node
  }, [])

  return [ref, setRef]
}
